"use client";

import { useEffect, useRef, type ReactNode } from "react";

export function BundleComparisonDialog({ children }: { children: ReactNode }) {
  const dialog = useRef<HTMLDialogElement>(null);
  const trigger = useRef<HTMLButtonElement>(null);
  const previousOverflow = useRef<string | null>(null);
  const restoreScroll = () => {
    if (previousOverflow.current !== null) {
      document.body.style.overflow = previousOverflow.current;
      previousOverflow.current = null;
    }
  };
  useEffect(() => () => restoreScroll(), []);
  function open() {
    if (!dialog.current || dialog.current.open) return;
    previousOverflow.current = document.body.style.overflow;
    document.body.style.overflow = "hidden";
    dialog.current.showModal();
  }
  return <>
    <button ref={trigger} type="button" aria-haspopup="dialog" onClick={open} className="inline-flex min-h-11 items-center gap-2 text-sm font-semibold text-ink underline underline-offset-4 focus-visible:rounded focus-visible:outline-2 focus-visible:outline-offset-4 focus-visible:outline-ink">Compare bundles <span aria-hidden="true">↗</span></button>
    <dialog ref={dialog} aria-labelledby="bundle-comparison-title" onClose={() => { restoreScroll(); trigger.current?.focus({ preventScroll: true }); }} onClick={event => {
      if (event.target !== event.currentTarget) return;
      const bounds = event.currentTarget.getBoundingClientRect();
      if (event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom) dialog.current?.close();
    }} className="m-auto max-h-[88dvh] w-[calc(100%-2rem)] max-w-6xl overflow-hidden rounded-xl border border-hairline bg-paper p-0 text-ink shadow-2xl backdrop:bg-slate-950/45 backdrop:backdrop-blur-sm">
      <div className="flex max-h-[88dvh] flex-col">
        <div className="flex shrink-0 items-center justify-between gap-4 border-b border-hairline bg-paper-raised px-5 py-4 sm:px-7">
          <h2 id="bundle-comparison-title" className="font-display text-xl font-semibold">Compare Edge bundles</h2>
          <button type="button" autoFocus onClick={() => dialog.current?.close()} className="inline-flex min-h-11 items-center justify-center gap-2 rounded border border-hairline px-4 text-sm font-semibold hover:bg-mist focus-visible:outline-2 focus-visible:outline-ink">Close <span aria-hidden="true">×</span></button>
        </div>
        <div className="min-h-0 overflow-y-auto overscroll-contain [&>section]:py-6">{children}</div>
      </div>
    </dialog>
  </>;
}
